import { useMemo } from "react";

import { isEmpty } from "lodash-es";

import {
  useResetURLParamsFilters,
  useURLParamsFilters,
} from "src/base-components/tableColumnFilters/useFilters";
import { FilterConfig } from "src/featureCatalogue/utils";

export const useFilteredData = <T>({
  items,
  filterConfig,
}: {
  items: T[];
  filterConfig: FilterConfig<T>;
}) => {
  const filters = useURLParamsFilters();
  const resetFilters = useResetURLParamsFilters();
  const hasActiveFilters = !isEmpty(filters);

  const filteredItems = useMemo(() => {
    let result = items;

    if (!isEmpty(filters)) {
      result = result.filter((item) => {
        const entityFilter = filters[filterConfig.entityFilterKey];
        if (entityFilter) {
          const values = entityFilter.split(",");
          if (
            !filterConfig.getEntityValues(item).some((v) => values.includes(v))
          ) {
            return false;
          }
        }

        const eventFilter = filters["filter[event][eq]"];
        if (eventFilter) {
          const values = eventFilter.split(",");
          if (!values.includes(filterConfig.getEvent(item))) {
            return false;
          }
        }

        const sandboxStatusFilter = filters["filter[sandbox_status][eq]"];
        if (sandboxStatusFilter) {
          const values = sandboxStatusFilter.split(",");
          const status = filterConfig.getSandboxStatus(item);
          if (!status || !values.includes(status)) {
            return false;
          }
        }

        const liveStatusFilter = filters["filter[live_status][eq]"];
        if (liveStatusFilter) {
          const values = liveStatusFilter.split(",");
          const status = filterConfig.getLiveStatus(item);
          if (!status || !values.includes(status)) {
            return false;
          }
        }

        return true;
      });
    }

    return result;
  }, [items, filters, filterConfig]);

  return { filteredItems, hasActiveFilters, resetFilters };
};
